import { Box, BoxProps } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";

interface BoxWithBackdropProps extends BoxProps {
  disabled: boolean;
  allowInteractions?: boolean;
}

export default function BoxWithBackdrop({
  disabled,
  allowInteractions = false,
  children,
  ...restProps
}: BoxWithBackdropProps) {
  return (
    <Box {...restProps} style={{ position: "relative" }}>
      {children}

      {/* Disable interaction + Dim foreground */}
      <Backdrop
        open={disabled}
        sx={{
          position: "absolute",
          zIndex: 10,
          backgroundColor: "rgba(244, 247, 248, 0.3)",
          pointerEvents: allowInteractions ? "none" : undefined, 
        }}
      />
    </Box>
  );
}
